module.exports = __webpack_public_path__ + "static/media/Xe.487a7e16.png";